export const content = {
  zeitraum: 'Zeitraum',
  sapId: 'SAP-ID (E)',
  experte: 'Trainer:in',
  experten: 'Trainer:innen',
  akaDurchgangId: 'AKA-Durchgang-ID',
  wo: 'Wo?',
  durchgangsart: 'Durchgangsart',
  geschaeftsbereich: 'Geschäftsbereich',
  manuellerAusschreibungsprozess: 'Manueller Ausschreibungsprozess',
};
